import { faEye } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row, Table } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import * as Common from "../Common";
import Dialog from '../Dialog';
import DialogYesNo from '../Dialog_Yes_No';
import LoginHeader from '../Login_header';
import Menu from '../Menu';
import * as Picklist from "../Picklist";
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import $ from "jquery";


const Bank_cheque_book_cancellation = () => {

    const sid = sessionStorage.getItem("sessionId");
    const navigate = useNavigate();
    const startDate = sessionStorage.getItem('startDate');
    const endDate = sessionStorage.getItem('endDate');
    const branchDisable = sessionStorage.getItem('branchDisable');

    const [cbOutLocationValue, setCbOutLocationValue] = useState(0);
    const [radioType, setRadioType] = useState("N");
    const [cbOutlocation, setCbOutLocation] = useState(null);
    const [remark, setRemark] = useState('');

    const [cbOutdate, setCbOutDate] = useState(new Date());
    const [cbOutBank, setCbOutBank] = useState(null);
    const [cbOutFromSrNo, setCbOutFromSrno] = useState("");
    const [cbOutToSrno, setCbOutToSrno] = useState("");
    const [cbOutFromDate, setCbOutFromDate] = useState(new Date());
    const [cbOutToDate, setCbOutToDate] = useState(new Date());

    const [location, setLocation] = useState("");
    const [bankName, setBankName] = useState("");

    const [locationCode, setLocationCode] = useState("");

    const [onceRun, setOnceRun] = useState(false);
    const [userRight, setUserRight] = useState([]);
    const [scrMode, setScrMode] = useState("");

    const [cbOutQuantity, setCbOutQuantity] = useState("");
    const [cbOutFrom, setCbOutFrom] = useState("");
    const [cbOutFromObj, setCbOutFromObj] = useState("");

    const [cbOutTo, setCbOutTo] = useState("");
    const [bankCode, setBankCode] = useState("");
    const [groupCode, setGroupCode] = useState("");



    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [msgTextYN, setMsgTextYN] = useState("");
    const [isMsgBox, setMsgBox] = useState(false);
    const [isUnclockMsgBoxYN, setIsUnclockMsgBoxYN] = useState(false);
    const [unlockMsgTextYN, setUnlockMsgTextYN] = useState('');

    const [msgText, setMsgText] = useState("");

    const [headerData, setHeaderData] = useState([]);
    const [unlockRequestObj, setUnlockRequestObj] = useState(null);
    const [filterFromChequeValue, setFilterFromChequeValue] = useState(null);
    const [filterFromChequeNo, setFilterFromChequeNo] = useState(null);


    var msg = [], i = 0;

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.getActiveBranch().then(response => {
                setCbOutLocation(response);
                response != null && handleChangeLocation(response);
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'CHEQUE_CANCELLATION'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/'); // no query right
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    const handleChangeQuantity = (e) => {
        Common.validateNumValue(e.target.value, setCbOutQuantity);
        if (e.target.value === '' || cbOutFrom === '') {
            setCbOutTo('');
        } else {
            setCbOutTo(1 * e.target.value + (1 * cbOutFrom - 1));
        }
    }


    const handleChangeFrom = (val) => {
        // Common.validateNumValue(e.target.value, setCbOutFrom);
        const id = val.id.split('^');
        setCbOutFrom(id[4]);
        setCbOutFromObj(val);
        //console.log(id)
        if (cbOutQuantity === '' || id[4] === '') {
            setCbOutTo('');
        } else {
            setCbOutTo((1 * cbOutQuantity) + (1 * id[4] - 1));
        }
    }

    const handleChangeLocation = (value) => {
        setCbOutLocation(value);
        var id = value.id;
        var locationVal = id.split('^');
        setCbOutLocationValue(locationVal[1]);
        setLocationCode(locationVal[1]);
        setLocation(locationVal[2]);
        // setCbInBank(null);
    }

    const handleBankValue = (value) => {
        setCbOutBank(value);
        const bnk = value.id.split('^');
        setGroupCode(bnk[1]);
        setBankCode(bnk[2]);
        setBankName(bnk[5]);
    }

    const addNew = () => {

        if (!cbOutlocation || (radioType == 'N' && !cbOutBank) || (radioType == 'N' && !cbOutdate)) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (!cbOutlocation ? 'Please select location' : '');
            msg[i++] = ((radioType == 'N' && !cbOutBank) ? 'Please select bank' : '');
            msg[i++] = ((radioType == 'N' && !cbOutdate) ? 'Please select date' : '');

            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            setScrMode('A');
            setCbOutFrom('')
            resetForm();
        }
    }
    const resetForm = () => {
        setCbOutTo('');
        setCbOutQuantity('');
        setCbOutFrom('');
        setRemark('');
        setCbOutFromObj('');
    }

    const chequeBooklist = () => {

        if (!cbOutlocation || (radioType == 'S' && cbOutFromSrNo == '') || (radioType == 'S' && !cbOutToSrno)
            || (radioType == 'D' && !cbOutFromDate) || (radioType == 'D' && !cbOutToDate) ||
            (radioType == 'C' && !filterFromChequeNo)) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (!cbOutlocation ? 'Please select location' : '');
            msg[i++] = ((radioType == 'S' && cbOutFromSrNo == '') ? 'Please enter from srno' : '');
            msg[i++] = ((radioType == 'S' && !cbOutToSrno) ? 'Please enter to srno' : '');
            msg[i++] = ((radioType == 'D' && !cbOutFromDate) ? 'Please select from date' : '');
            msg[i++] = ((radioType == 'D' && !cbOutToDate) ? 'Please select to date' : '');
            msg[i++] = ((radioType == 'C' && !filterFromChequeNo) ? 'Please select Cheque No' : '');

            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                location: cbOutLocationValue,
                fromSrno: cbOutFromSrNo,
                toSrno: cbOutToSrno,
                fromDate: Common.dateYMD(cbOutFromDate),
                toDate: Common.dateYMD(cbOutToDate),
                radioType: radioType,
                fromCheckNo: filterFromChequeNo
            }
            Common.callApi(Common.apiCancelChequeBook, [sid, 'getCancelledCheque', JSON.stringify(obj)], (result) => {
                console.log(result);
                let resp = JSON.parse(result);
                setHeaderData(resp)
            })
        }
    }

    const cancelCheque = () => {
        if (!cbOutQuantity || !cbOutFrom || !cbOutTo) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (!cbOutQuantity ? 'Please enter quantity' : '');
            msg[i++] = (!cbOutFrom ? 'Please enter from' : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                quantity: cbOutQuantity,
                from: cbOutFrom,
                to: cbOutTo,
                date: Common.dateYMD(cbOutdate),
                location: cbOutLocationValue,
                radioType: radioType,
                remark: remark,
                groupCode: groupCode,
                bankCode: bankCode,
                fromCheckNo: filterFromChequeNo,
                cbOutFromObj: cbOutFromObj
            }

            Common.callApi(Common.apiCancelChequeBook, [sid, 'cancelChequeBook', JSON.stringify(obj)], (result) => {
                let resp = JSON.parse(result);
                if (resp.status) {
                    setHeaderData(resp.data)
                    setScrMode('');
                    setCbOutQuantity('');
                    setRemark('');
                    setCbOutFromObj('');
                    setCbOutTo('');
                } else {
                    setMsgText(resp.data);
                    setMsgBox(true);
                }

            })
        }
    }

    const cancelConfirm = () => {
        if (scrMode === "A" || scrMode === "E") {
            setMsgTextYN('Do you really want to exit ?');
            setMsgBoxYN(true);
        } else {
            cancelData();
        }
    }

    const cancelData = () => {
        setMsgBoxYN(false);
        setScrMode("");
    }

    function deleteChequeBookHandler(res) {
        $(".loader").show();
        setUnlockRequestObj(res);
        const obj = {
            //list data keys
            // tdu_tran_srno: item.tcbb_out_srno,
            outSrno: res.tcbb_out_srno,
            // manualType: item.tmbb_manual_type,
            // filterRadioType: radioType,
            fromChequeNo: res.tcbb_from,
            outLineNo: res.tcbb_out_srno,
            // tcbb_type: res.tcbb_type,
            tcbb_srno: res.tcbb_srno,
            location: locationCode,
            fromSrno: cbOutFromSrNo,
            toSrno: cbOutToSrno,
            fromDate: cbOutFromDate,
            toDate: cbOutToDate,
            radioType: radioType,
            fromCheckNo: filterFromChequeNo,
            tcbb_type: res.tcbb_type,
            tcbb_out_type: res.tcbb_out_type,
            tcbb_out_line_no: res.tcbb_out_line_no
        }
        Common.callApi(Common.apiCancelChequeBook, [sid, 'reviokeCancelChequeBook', JSON.stringify(obj)], (result) => {
            $(".loader").hide();
            let resp = JSON.parse(result);
            if (resp.status === true) {
                setHeaderData(resp.data);
            } else {
                if (resp.isLock && resp.data != 'Request already Pending.') {
                    setIsUnclockMsgBoxYN(true);
                    setUnlockMsgTextYN(resp.data);
                } else {
                    setMsgBoxYN(true);
                    setMsgTextYN(resp.data);
                }
            }

        })
    }

    function sendUnlockRequest() {
        $(".loader").show();
        const obj = {
            outLineNo: unlockRequestObj.tcbb_out_srno,
            location: locationCode,
            outSrno: unlockRequestObj.tcbb_out_srno,
        }
        Common.callApi(Common.apiCancelChequeBook, [sid, 'unlockRequest', JSON.stringify(obj)], (result) => {
            $(".loader").hide();
            let resp = JSON.parse(result);
            console.log(resp);
            setIsUnclockMsgBoxYN(false)//close unlock model.
            setMsgBoxYN(true);
            setMsgTextYN(resp.data);
        });
    }

    const cancelledChequeFilterHandler = (val) => {
        const id = val.id.split('^')
        setFilterFromChequeNo(id[4]);
        setFilterFromChequeValue(val)
        console.log(id)
    }


    return (
        <div>
            <LoginHeader />
            <Menu />

            <Container fluid>
                <Row>
                    <Col>
                        <h2>Cheque Book Cancellation</h2>
                    </Col>
                </Row>&nbsp;

                {
                    scrMode == '' ?
                        <>
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Location<span className="text-danger">*</span></Form.Label>
                                        <AsyncSelect
                                            cacheOptions={false}
                                            defaultOptions={false}
                                            value={cbOutlocation}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={Picklist.fetchLocationAllowedPicklist}
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={handleChangeLocation}
                                            isDisabled={branchDisable === "true"}
                                        >
                                        </AsyncSelect>
                                    </Form.Group>
                                </Col>
                                <Col className='col-md-4 col-6'>
                                    <Form.Group>
                                        <Row style={{ marginTop: "30px" }}>
                                            <Col>
                                                <Form.Check checked={radioType === "N"} onChange={() => setRadioType("N")} type='radio' label="New" />
                                            </Col>
                                            {/* <Col>
                                                <Form.Check checked={radioType === "S"} onChange={() => setRadioType("S")} type='radio' label="SrNo" />
                                            </Col> */}
                                            <Col>
                                                <Form.Check checked={radioType === "D"} onChange={() => setRadioType("D")} type='radio' label="Date" />
                                            </Col>
                                            <Col>
                                                <Form.Check checked={radioType === "C"} onChange={() => setRadioType("C")} type='radio' label="Cheque No" />
                                            </Col>
                                        </Row>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                {
                                    radioType === 'N' ?
                                        <>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>Date<span className="text-danger">*</span></Form.Label>
                                                    <DatePicker className="form-control"
                                                        selected={cbOutdate}
                                                        minDate={new Date(startDate)}
                                                        maxDate={new Date(endDate)}
                                                        onChange={(date) => setCbOutDate(date)}
                                                        dateFormat="dd/MM/yyyy"
                                                        showYearDropdown
                                                        showMonthDropdown
                                                        useShortMonthInDropdown
                                                        dropdownMode="select"
                                                        peekNextMonth
                                                        customInput={
                                                            <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                        }
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>Bank<span className="text-danger">*</span></Form.Label>
                                                    <AsyncSelect
                                                        cacheOptions={false}
                                                        defaultOptions={false}
                                                        value={cbOutBank}
                                                        getOptionLabel={e => e.label + ' '}
                                                        getOptionValue={e => e.id}
                                                        loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'BANK', cbOutLocationValue)}
                                                        onInputChange={Picklist.handleInputChange}
                                                        onChange={handleBankValue}
                                                    >
                                                    </AsyncSelect>
                                                </Form.Group>
                                            </Col>
                                        </>
                                        :
                                        radioType === 'S' ?
                                            <>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>From<span className="text-danger">*</span></Form.Label>
                                                        <Form.Control value={cbOutFromSrNo}
                                                            maxLength={20}
                                                            // onChange={(e) => setCbOutFromSrno(e.target.value)}
                                                            onChange={(e) => Common.validateNumValue(e.target.value, setCbOutFromSrno)}
                                                            placeholder="From" />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>To<span className="text-danger">*</span></Form.Label>
                                                        <Form.Control value={cbOutToSrno}
                                                            maxLength={20}
                                                            // onChange={(e) => setCbOutToSrno(e.target.value)}
                                                            onChange={(e) => Common.validateNumValue(e.target.value, setCbOutToSrno)}
                                                            placeholder="To" />
                                                    </Form.Group>
                                                </Col>
                                            </>
                                            :
                                            radioType === 'D' ?
                                                <>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                            <DatePicker className="form-control"
                                                                selected={cbOutFromDate}
                                                                onChange={(date) => setCbOutFromDate(date)}
                                                                dateFormat="dd/MM/yyyy"
                                                                showYearDropdown
                                                                showMonthDropdown
                                                                useShortMonthInDropdown
                                                                dropdownMode="select"
                                                                peekNextMonth
                                                                customInput={
                                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                }
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                            <DatePicker className="form-control"
                                                                selected={cbOutToDate}
                                                                onChange={(date) => setCbOutToDate(date)}
                                                                dateFormat="dd/MM/yyyy"
                                                                showYearDropdown
                                                                showMonthDropdown
                                                                useShortMonthInDropdown
                                                                dropdownMode="select"
                                                                peekNextMonth
                                                                customInput={
                                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                }
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </>
                                                : radioType === 'C' ?
                                                    <>
                                                        <Col className='col-md-3 col-6'>
                                                            <Form.Group>
                                                                <Form.Label>Cheque Number</Form.Label>
                                                                <AsyncSelect
                                                                    cacheOptions={false}
                                                                    defaultOptions={false}
                                                                    value={filterFromChequeValue}
                                                                    getOptionLabel={e => e.label + ' '}
                                                                    getOptionValue={e => e.id}
                                                                    loadOptions={(search) => Picklist.fetchCancelledChequeBookBankPicklist(search, groupCode, bankCode, locationCode)}
                                                                    onInputChange={Picklist.handleInputChange}
                                                                    onChange={cancelledChequeFilterHandler}
                                                                >
                                                                </AsyncSelect>
                                                            </Form.Group>
                                                        </Col>
                                                    </> :
                                                    null
                                }
                            </Row>&nbsp;
                            <Row>
                                <Col>
                                    {
                                        userRight.add === "1" && radioType == 'N' ?
                                            <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => addNew()}>Add New</Button> : null
                                    }
                                    &nbsp;
                                    {
                                        userRight.query === "1" && radioType !== 'N' ?
                                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => chequeBooklist()}>List</Button>
                                            : null
                                    }
                                    &nbsp;
                                    <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => navigate('/cancellation')}>Back</Button>&nbsp;
                                </Col>
                            </Row>&nbsp;
                            <Row>
                                <Table responsive striped bordered hover>
                                    <thead>
                                        <tr>
                                            {userRight.edit === "1" ? <th></th> : null}
                                            {/* <th>SrNo</th> */}
                                            <th>Cheque No.</th>
                                            <th>Date</th>
                                            <th>Remark</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {headerData.map((res) =>
                                            <tr key={res.hdr_srno}>
                                                {userRight.edit === "1" ?
                                                    <td className="textCenter">
                                                        <span className="handCursor colorThemeBlue"
                                                            onClick={() => deleteChequeBookHandler(res)}
                                                        >
                                                            <FontAwesomeIcon icon={faTrash} />
                                                        </span>
                                                    </td>
                                                    : null
                                                }
                                                {/* <td>{res.tcbb_srno}</td> */}
                                                <td>{res.tcbb_from}</td>
                                                <td>{res.formatted_date}</td>
                                                <td>{res.tcbb_cancel_remark}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </Row>
                        </> : <>
                            <Row>
                                <Col>
                                    <Button variant='outline-danger' className='buttonStyle' size='sm' onClick={() => cancelConfirm()}>Back</Button>{' '}
                                </Col>
                            </Row>&nbsp;

                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Label>Location : {location}</Form.Label>
                                </Col>
                                <Col className='col-md-3 col-6'>
                                    <Form.Label>Bank : {bankName}</Form.Label>
                                </Col>
                            </Row>&nbsp;

                            {
                                scrMode === 'E' || scrMode === 'A' ?
                                    <>
                                        <Row>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>Quantity<span className="text-danger">*</span></Form.Label>
                                                    <Form.Control value={cbOutQuantity}
                                                        onChange={(e) => handleChangeQuantity(e)}
                                                        placeholder="Quantity" />
                                                </Form.Group>
                                            </Col>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>From<span className="text-danger">*</span></Form.Label>
                                                    {/* <Form.Control value={cbOutFrom}
                                                        maxLength={20}
                                                        onChange={(e) => handleChangeFrom(e)}
                                                        placeholder="From" /> */}
                                                    {/* <Form.Label>From<span className="colorThemeRed">*</span></Form.Label> */}
                                                    <AsyncSelect
                                                        cacheOptions={false}
                                                        defaultOptions={false}
                                                        value={cbOutFromObj}
                                                        getOptionLabel={e => e.label + ' '}
                                                        getOptionValue={e => e.id}
                                                        loadOptions={(search) => Picklist.fetchChequeBookBankPicklist(search, groupCode, bankCode, locationCode)}
                                                        onInputChange={Picklist.handleInputChange}
                                                        onChange={handleChangeFrom}
                                                    >
                                                    </AsyncSelect>
                                                    {/* </Form.Group> */}
                                                </Form.Group>
                                            </Col>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>To</Form.Label>
                                                    <Form.Control value={cbOutTo}
                                                        maxLength={20}
                                                        onChange={(e) => setCbOutTo(e.target.value)}
                                                        placeholder="To"
                                                        disabled />
                                                </Form.Group>
                                            </Col>
                                            <Col className='col-md-4 col-6'>
                                                <Form.Group>
                                                    <Form.Label>Remark<span className="text-danger">*</span></Form.Label>
                                                    <Form.Control value={remark}
                                                        onChange={(e) => setRemark(e.target.value)}
                                                        placeholder="Remark" />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row style={{ marginTop: "30px" }}>
                                            <Col className='col-md-3 col-6'>
                                                {
                                                    userRight.add === "1" ?
                                                        <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => cancelCheque()}>Cancel Cheque Book</Button> : null
                                                }
                                            </Col>
                                        </Row>
                                    </> :
                                    null
                            }
                        </>

                }


            </Container>
            <>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
                <DialogYesNo isOpen={isMsgBoxYN} onYes={(e) => cancelData()} onNo={(e) => setMsgBoxYN(false)}>
                    {msgTextYN}
                </DialogYesNo>
                <DialogYesNo isOpen={isUnclockMsgBoxYN} onYes={(e) => sendUnlockRequest()} onNo={(e) => setIsUnclockMsgBoxYN(false)}>
                    {unlockMsgTextYN}
                </DialogYesNo>
            </>
        </div>
    )
}

export default Bank_cheque_book_cancellation
